import { Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { IntegrationsOverviewHeader } from '@/features/integrations/overview/components/overview-header'
import { IntegrationsOverviewSkeleton } from '@/features/integrations/overview/components/skeletons'
import { integrationsOverviewQueries } from '@/features/integrations/overview/queries'
import { lazyNamed } from '@/utils/lazy-named'

import { getCurrentTenant } from '@/shared/auth/store'

import { ErrorBoundary } from '@/components/common/error-boundary'

const IntegrationsOverviewSection = lazyNamed(
	() => import('@/features/integrations/overview/components/overview'),
	'IntegrationsOverviewSection',
)

export const Route = createFileRoute('/_dashboard/integrations/')({
	loader: ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant()

		// Prefetch what the overview suspends on, so navigation renders a warm
		// cache instead of waterfalling on first paint (A-07).
		if (tenant)
			queryClient.prefetchQuery(integrationsOverviewQueries.summary(tenant))
	},

	head: () => ({
		meta: [{ title: 'Integrations | BitLyft AIR®' }],
	}),

	component: IntegrationsOverviewPage,
	pendingComponent: IntegrationsOverviewPendingPage,
	errorComponent: RouteErrorComponent,
})

function IntegrationsOverviewPage() {
	return (
		<>
			<IntegrationsOverviewHeader />

			<ErrorBoundary feature="integrations" section="overview">
				<Suspense fallback={<IntegrationsOverviewSkeleton />}>
					<IntegrationsOverviewSection />
				</Suspense>
			</ErrorBoundary>
		</>
	)
}

function IntegrationsOverviewPendingPage() {
	return (
		<>
			<IntegrationsOverviewHeader />
			<IntegrationsOverviewSkeleton />
		</>
	)
}
